/** About page content. /aabout: the cards are collectibles (Figma "Frame 975" /
 *  "976"): a skill on the front (`skill`), the NTO mark on the back; the first
 *  card's front is the photo. The fields below that (front, back, colours) are
 *  /aabout2's.
 *  The cards top to bottom as the deck fans out. Each card
 *  has a capability on its front (seen while the deck opens) and one on its back
 *  (seen once the cards have turned over while it closes). The first card's
 *  front is the photo (public/about/portrait-*.webp, 800/1200/2000/3364 wide);
 *  the last card's back stays empty: it ends on top and becomes the modal. */
type Capability = { title: string; text: string }
/** a collectible card's front (/aabout: Figma "Frame 975"): the skill's name, its number and rarity */
type Skill = { title: string; no: string; rarity: string }
type Card = { color: string; ink: string; photo?: string; fly?: boolean; front?: Capability; back?: Capability; skill?: Skill }

export const ABOUT = {
    cards: [
        {
            color: "#b3b3b3",
            ink: "#000",
            photo: "/about/portrait-3364.webp",
            back: { title: "Creative\ndirection", text: "Concept and vision, from first idea to the final frame." },
        },
        {
            skill: { title: "Creative\ndirection", no: "01", rarity: "Common" },
            color: "#ff0000",
            ink: "#fff",
            front: { title: "Strategy\n& concept", text: "Positioning and ideas that give the work its direction." },
            back: { title: "Brand\nidentity", text: "Identities and systems that hold up everywhere they go." },
        },
        {
            skill: { title: "Brand\nidentity", no: "02", rarity: "Common" },
            color: "#fff500",
            ink: "#000",
            front: { title: "Design\nsystems", text: "Components and rules that keep every touchpoint consistent." },
            back: { title: "Digital\nproducts", text: "Websites and apps, designed and built to the pixel." },
        },
        {
            // (only in the six-card version, /aabout2)
            fly: true,
            color: "#05ffd2",
            ink: "#000",
            front: { title: "Proto-\ntyping", text: "Ideas made real early, to feel and test before building." },
            back: { title: "Motion\ndesign", text: "Interfaces and identities that move with intent." },
        },
        {
            skill: { title: "Digital\nproducts", no: "03", rarity: "Common" },
            color: "#8e49ff",
            ink: "#fff",
            front: { title: "Art\ndirection", text: "Photography, styling and tone of voice, shoot by shoot." },
            back: { title: "Campaign\n& motion", text: "Films, launches and the work that makes them move." },
        },
        {
            skill: { title: "Campaign\n& motion", no: "04", rarity: "Common" },
            color: "#2b2b2b",
            ink: "#fff",
            front: { title: "UX &\ninteraction", text: "Flows and details that make things feel obvious to use." },
        },
    ] as Card[],
    /** over the photo while it's full screen (fades as it starts to shrink), from tablets up */
    intro: "Tiago Nascimento, based in Europe, 20 years working across digital\nexperiences, emerging interfaces, and brands. Previously Head of Design at DEPT®,\nand now working directly with clients to shape what comes next.",
    /** the same on phones: two paragraphs, their own line breaks */
    introPhone:
        "Tiago Nascimento, based in Europe, 20 years working\nacross digital experiences, emerging interfaces, and brands.\n\nPreviously Head of Design at DEPT®, and now working\ndirectly with clients to shape what comes next.",
    modal: {
        title: "Get in touch",
        text: "A project, a question or just a hello: tell me about it.",
        thanks: "Thank you. I'll get back to you soon.",
    },
}
